import API from './client'

export const authAPI = {
  login: (phone: string) =>
    API.post('/auth/login', { phone }),

  register: (phone: string, name: string, role: string) =>
    API.post('/auth/register', { phone, name, role }),

  verifyOTP: (phone: string, code: string) =>
    API.post('/auth/verify-otp', { phone, code }),

  logout: () =>
    API.post('/auth/logout'),

  me: () =>
    API.get('/auth/me'),

  loginEmail: (email: string, password: string) =>
    API.post('/auth/login-email', { email, password }),

  registerEmail: (email: string, password: string, name: string, role: string) =>
    API.post('/auth/register-email', { email, password, name, role }),

  forgotPassword: (email: string) =>
    API.post('/auth/forgot-password', { email }),
}
